// @flow
import fetchFromApiServer from '../../../service/index';

export function getRewardDetail(rewardUrl,_uid){
    const raw = rewardUrl == null ? '' : String(rewardUrl);
    const encoded = raw === '' ? '' : encodeURIComponent(raw);
    var url = 'WMSDetail/GetRewardDetail?rewardUrl=' + encoded;
    return {
      type:'GET_REWARD_DETAIL',
      payload:fetchFromApiServer("GET", url)
    }
  }

  function rewardListBody(uid, tab) {
    const key = uid != null && String(uid).trim() !== '' ? String(uid) : '';
    return { UserKey: key, tab, Tab: tab };
  }

  export function getRewardInsideList(uid, tab){
    var url = 'WMSDetail/GetOrderDetail';
    var obj = rewardListBody(uid, tab)
    return {
      type:'GET_REWARD_INSIDE_LIST',
      payload:fetchFromApiServer("POST", url, obj)
    }
  }

  export function getExpiredList(uid, tab){
    var url = 'WMSDetail/GetCustomerHistory';
    var obj = rewardListBody(uid, tab)
    return {
      type:'GET_REWARD_EXPIRED_LIST',
      payload:fetchFromApiServer("POST", url, obj)
    }
  }

  export function getPaidList(uid, tab){
    var url = 'WMSDetail/GetMaintenancePaid';
    var obj = rewardListBody(uid, tab)
    return {
      type:'GET_PAID_LIST',
      payload:fetchFromApiServer("POST", url, obj)
    }
  }
  export function getRewardList(uid, tab){
    var url = 'WMSDetail/GetRedeemOrder';
    var obj = rewardListBody(uid, tab)
    return {
      type:'GET_REWARD_LIST',
      payload:fetchFromApiServer("POST", url, obj)
    }
  }

  export function getReedemCode(obj){
    var url = 'WMSDetail/GetRedeemCode'
    return {
      type:'GET_REDEEM_CODE',
      payload:fetchFromApiServer("POST", url, obj)
    }
  }
  export function submitReedemCode(obj){
    var url = 'WMSDetail/RedeemCoupon'
    return {
      type:'SUBMIT_REDEEM_CODE',
      payload:fetchFromApiServer("POST", url, obj)
    }
  }

  // export function showOrHideDetailOfItem(AdKey,index){
  //   return {
  //     type:'SHOW_HIDE_REWARD_DETAIL',
  //     AdKey:AdKey,
  //     index:index
  //   }
  // }
  // export function showOrHideDetailOfExpiredItem(AdKey,index){
  //   return {
  //     type:'SHOW_HIDE_EXPIRED_DETAIL',
  //     AdKey:AdKey,
  //     index:index
  //   }
  // }

  export function storeQRCode(qrCode,item,uid){
    return {
      type:'GET_QR_CODE',
      qrCode:qrCode,
      item:item,
      uid:uid
    }
  }
  